import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { WhatsAppIcon } from "./Icons";
import { NAV, TEL, WA, PHONE_DISPLAY } from "../../lib/site";

const linkCls = ({ isActive }) =>
  `relative whitespace-nowrap py-2 text-[13.5px] font-medium transition-colors duration-200 ${
    isActive ? "text-emerald-900 after:absolute after:inset-x-0 after:-bottom-0.5 after:h-px after:bg-gold" : "text-ink/70 hover:text-emerald-800"
  }`;

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header data-testid="site-header" className="sticky top-0 z-50 border-b border-gold/25 bg-cream/95 backdrop-blur-md">
      <div className="container-lux flex h-[68px] items-center justify-between gap-4 lg:h-[76px]">
        <Logo className="h-11 lg:h-14" />
        <nav className="hidden items-center gap-4 xl:flex 2xl:gap-6" aria-label="Ana menü">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end className={linkCls} data-testid={`nav-${n.to.replace(/\//g, "") || "home"}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <a href={TEL} className="hidden items-center gap-2 whitespace-nowrap text-sm font-medium text-emerald-900 lg:flex xl:hidden 2xl:flex" data-testid="header-phone-link">
            <Phone className="h-4 w-4 text-gold-deep" strokeWidth={1.8} /> {PHONE_DISPLAY}
          </a>
          <a href={WA} target="_blank" rel="noopener noreferrer" className="btn-gold !px-4 !py-2.5 sm:!px-5" data-testid="header-randevu-btn">
            <WhatsAppIcon className="h-4 w-4" /> <span>Randevu Al</span>
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-emerald-900/15 text-emerald-900 transition-colors hover:border-gold xl:hidden"
            aria-label={open ? "Menüyü kapat" : "Menüyü aç"}
            aria-expanded={open}
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <nav data-testid="mobile-menu" className="border-t border-gold/20 bg-cream xl:hidden" aria-label="Mobil menü">
          <ul className="container-lux flex flex-col py-3">
            {NAV.map((n) => (
              <li key={n.to} className="border-b border-gold/10 last:border-0">
                <NavLink
                  to={n.to}
                  end
                  data-testid={`mobile-nav-${n.to.replace(/\//g, "") || "home"}`}
                  className={({ isActive }) => `block py-3.5 text-[15px] font-medium ${isActive ? "text-emerald-900" : "text-ink/75"}`}
                >
                  {n.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </header>
  );
};
